const CONTACT_GOV_ID_VALIDATION_REGEXES = {
  SSN: '^([0-9]{9}|[0-9]{5})$',
  NIN: '^(([A-CEGHJ-PR-TW-Z]|[a-ceghj-pr-tw-z]){1}([A-CEGHJ-NPR-TW-Z]|[a-ceghj-npr-tw-z]){1}[0-9]{6}([A-D]|[a-d]){1})$',
} as const;

export default CONTACT_GOV_ID_VALIDATION_REGEXES;
